import { render, staticRenderFns } from "./ResumoAverbacoes.vue?vue&type=template&id=611a8f50&"
import script from "./ResumoAverbacoes.vue?vue&type=script&lang=js&"
export * from "./ResumoAverbacoes.vue?vue&type=script&lang=js&"
import style0 from "./ResumoAverbacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports